export enum TachographModel {
  MODEL_4_1 = 'model-4-1',
  MODEL_4_0 = 'model-4-0',
  ANALOG = 'analog',
}
